export const generateEtsySeoPrompt = (
  keywords: string,
) => `as a etsy listing manager, write a title and tag of a listing for the following product
${keywords}
give the title output in the first line within 140 characters
give me 50 related tags, each tag within 20 characters, all comma separated
  `;
